module.exports = __webpack_public_path__ + "static/media/docusign.e366b8a5.png";